/* RAMMO Coastal interactions — ported from the approved draft-02 concept.
   Idempotent: safe to re-run on shopify:section:load (theme editor). */
(function () {
  'use strict';
  var motionPref = window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealObserver = null;

  function initComparisons(root) {
    root.querySelectorAll('.rc-comparison').forEach(function (comparison) {
      if (comparison.dataset.rcInit) return;
      comparison.dataset.rcInit = '1';
      var input = comparison.querySelector('input[type="range"]');
      var surface = comparison.querySelector('.rc-comparison-images');
      if (!input || !surface) return;
      var update = function () {
        comparison.style.setProperty('--rc-split', input.value + '%');
        input.setAttribute('aria-valuetext', input.value + ' percent before photo visible');
      };
      input.addEventListener('input', update);
      update();
      var move = function (e) {
        var rect = surface.getBoundingClientRect();
        if (!rect.width) return;
        input.value = String(Math.round(Math.max(0, Math.min(100, (e.clientX - rect.left) / rect.width * 100))));
        update();
      };
      var dragging = false;
      surface.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        dragging = true;
        surface.setPointerCapture(e.pointerId);
        input.focus({ preventScroll: true });
        move(e);
      });
      surface.addEventListener('pointermove', function (e) { if (dragging) move(e); });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) {
        surface.addEventListener(ev, function () { dragging = false; });
      });
    });
  }

  function initVideoLaunchers(root) {
    root.querySelectorAll('.rc-video-launch').forEach(function (button) {
      if (button.dataset.rcInit) return;
      button.dataset.rcInit = '1';
      button.addEventListener('click', function () {
        var id = button.dataset.videoId;
        if (!id) return;
        var frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1';
        frame.title = button.dataset.videoTitle || 'Product demonstration video';
        frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.allowFullscreen = true;
        frame.tabIndex = 0;
        button.replaceWith(frame);
        frame.focus();
      });
    });
  }

  function initReveals(root) {
    if (motionPref.matches || !('IntersectionObserver' in window)) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var siblings = el.parentElement ? Array.prototype.slice.call(el.parentElement.children) : [];
          var stagger = (el.matches('.rc-category, .rc-product-card')) ? (siblings.indexOf(el) % 3) * 85 : 0;
          el.style.animationDelay = stagger ? stagger + 'ms' : '';
          el.classList.add('rc-in');
          revealObserver.unobserve(el);
        });
      }, { threshold: 0.12 });
    }
    root.querySelectorAll('.rc-reveal, .rc-reveal-photo').forEach(function (el) {
      if (el.dataset.rcObserved) return;
      el.dataset.rcObserved = '1';
      revealObserver.observe(el);
    });
  }

  var onMotionChange = function () {
    if (!motionPref.matches) return;
    if (revealObserver) { revealObserver.disconnect(); revealObserver = null; }
  };
  if (typeof motionPref.addEventListener === 'function') {
    motionPref.addEventListener('change', onMotionChange);
  } else if (typeof motionPref.addListener === 'function') {
    motionPref.addListener(onMotionChange);
  }

  /* Counter: binds ONLY to [data-rc-count] (never used on prices). Counts
     0 -> target once on scroll entry with an ease-out slowdown. Reduced
     motion or no-JS keeps the server-rendered final value. */
  function initCounters(root) {
    var els = root.querySelectorAll('[data-rc-count]');
    if (!els.length) return;
    els.forEach(function (el) {
      if (el.dataset.rcCountInit) return;
      el.dataset.rcCountInit = '1';
      var target = parseInt(el.dataset.rcCount, 10);
      if (!target || motionPref.matches || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(el);
          var start = null;
          var duration = 1600;
          var step = function (ts) {
            if (motionPref.matches) { el.textContent = target.toLocaleString('en-US'); return; }
            if (start === null) start = ts;
            var t = Math.min(1, (ts - start) / duration);
            var eased = 1 - Math.pow(1 - t, 3);
            el.textContent = Math.round(target * eased).toLocaleString('en-US');
            if (t < 1) requestAnimationFrame(step);
          };
          el.textContent = '0';
          requestAnimationFrame(step);
        });
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }

  function initRibbons(root) {
    root.querySelectorAll('[data-rc-ribbon]').forEach(function (ribbon) {
      if (ribbon.dataset.rcInit) return;
      ribbon.dataset.rcInit = '1';
      var toggle = ribbon.querySelector('.rc-ribbon-toggle');
      if (!toggle) return;
      if (!motionPref.matches) toggle.hidden = false;
      toggle.addEventListener('click', function () {
        var paused = ribbon.classList.toggle('rc-ribbon--paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.textContent = paused ? 'Play' : 'Pause';
      });
    });
  }

  var HASH_GROUPS = { '#home-care': 'home', '#warrior': 'warrior', '#pet': 'pet', '#all': 'all' };

  function applyCollectionFilter(group) {
    document.querySelectorAll('.rc-filters a').forEach(function (a) {
      if (a.dataset.rcFilter === group) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
    document.querySelectorAll('.rc-product-card').forEach(function (card) {
      if (group === 'all' || card.dataset.group === group) card.removeAttribute('hidden');
      else card.setAttribute('hidden', '');
    });
  }

  function initCollectionFilters(root) {
    var nav = root.querySelector ? root.querySelector('.rc-filters') : null;
    if (!nav || nav.dataset.rcInit) return;
    nav.dataset.rcInit = '1';
    nav.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[data-rc-filter]') : null;
      if (!a) return;
      applyCollectionFilter(a.dataset.rcFilter);
    });
    var fromHash = HASH_GROUPS[location.hash];
    if (fromHash && fromHash !== 'all') applyCollectionFilter(fromHash);
    window.addEventListener('hashchange', function () {
      var g = HASH_GROUPS[location.hash];
      if (g) applyCollectionFilter(g);
    });
  }

  function initAll(root) {
    initComparisons(root);
    initVideoLaunchers(root);
    initReveals(root);
    initCollectionFilters(root);
    initCounters(root);
    initRibbons(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
